import React, { useState } from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";
import PurchaseOrderGrid from "presentation/components/PurchaseOrder/PurchaseOrderGrid";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import { TabPanel, TabView } from "primereact/tabview";
import PurchaseOrderMonthlySummary from "presentation/components/PurchaseOrder/PurchaseOrderMonthlySummary";

const PurchaseOrderGridPage = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const { isLoading: isPermissionLoading } = usePermissionCheck({
    requiredFunction: "purchaseOrders",
  });

  const [activeIndex, setActiveIndex] = useState<number>(0);

  if (isPermissionLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <FunctionHeader title="Ordens de Compra" />

      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <TabPanel header="Ordens de Compra">
          <PurchaseOrderGrid />
        </TabPanel>

        <TabPanel header="Resumo Mensal">
          <PurchaseOrderMonthlySummary />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default PurchaseOrderGridPage;
